import { defineComponent as f, useSlots as B, openBlock as l, createBlock as m, unref as n, normalizeClass as i, createSlots as S, withCtx as a, renderSlot as d, createElementBlock as x, Fragment as k, renderList as I, createElementVNode as N } from "vue";
import "./ghl-ui.es255.js";
import C from "./ghl-ui.es174.js";
import y from "./ghl-ui.es256.js";
import w from "./ghl-ui.es257.js";
const P = ["src"], A = f({
  name: "UICarousel",
  inheritAttrs: !1,
  components: { NCarousel: y, NCarouselItem: w }
}), D = f({
  ...A,
  props: {
    showArrow: Boolean,
    autoPlay: Boolean,
    direction: {
      type: String,
      default: "horizontal"
    },
    dotPlacement: {
      type: String,
      default: "bottom"
    },
    dotType: {
      type: String,
      default: "dot"
    },
    itemsPerView: {
      type: [Number, String],
      default: 1
    },
    spaceBetweenItems: {
      type: Number,
      default: 0
    },
    draggable: Boolean,
    loop: Boolean,
    centeredItems: Boolean,
    mousewheel: Boolean,
    showDots: Boolean,
    interval: {
      type: Number,
      default: 5e3
    },
    effect: {
      type: String,
      default: "slide"
    },
    touchable: {
      type: Boolean,
      default: !0
    },
    transitionProps: {
      type: Object,
      default: void 0
    },
    transitionStyle: {
      type: Object,
      default: () => ({
        transitionDuration: "300ms"
      })
    },
    carouselItems: {
      type: Array,
      default: void 0
    },
    classNames: String,
    currentIndex: {
      type: Number,
      default: void 0
    }
  },
  emits: ["onUpdatedIndex"],
  setup(e, { emit: h }) {
    const g = h, c = B(), b = (o, u) => {
      g("onUpdatedIndex", o, u);
    };
    return (o, u) => (l(), m(n(y), {
      "show-arrow": e.showArrow,
      autoplay: e.autoPlay,
      direction: e.direction,
      "dot-type": e.dotType,
      "dot-placement": e.dotPlacement,
      class: i(e.classNames),
      "slides-per-view": e.itemsPerView,
      "space-between": e.spaceBetweenItems,
      draggable: e.draggable,
      loop: e.loop,
      "centered-slides": e.centeredItems,
      mousewheel: e.mousewheel,
      "show-dots": e.showDots,
      touchable: e.touchable,
      interval: e.interval,
      effect: e.effect,
      "transition-props": e.transitionProps,
      "transition-style": e.transitionStyle,
      "current-index": e.currentIndex,
      "on-update:current-index": b
    }, S({
      dots: a(({ total: t, currentIndex: r, to: s }) => [
        d(o.$slots, "customDots", {
          total: t,
          currentIndex: r,
          changeTo: s
        }, void 0, !0)
      ]),
      default: a(() => [
        n(c).customRender ? d(o.$slots, "customRender", { key: 0 }, void 0, !0) : (l(!0), x(k, { key: 1 }, I(e.carouselItems, (t) => (l(), m(n(w), {
          key: t.key,
          class: i(t == null ? void 0 : t.class)
        }, {
          default: a(() => [
            N("img", {
              src: t.src,
              class: i(`ghl-carousel-image-${t.key}`)
            }, null, 10, P)
          ]),
          _: 2
        }, 1032, ["class"]))), 128))
      ]),
      _: 2
    }, [
      n(c).customArrows ? {
        name: "arrow",
        fn: a(({ total: t, to: r, currentIndex: s, prev: p, next: v }) => [
          d(o.$slots, "customArrows", {
            total: t,
            currrentIndex: s,
            to: r,
            prev: p,
            next: v
          }, void 0, !0)
        ]),
        key: "0"
      } : void 0
    ]), 1032, ["show-arrow", "autoplay", "direction", "dot-type", "dot-placement", "class", "slides-per-view", "space-between", "draggable", "loop", "centered-slides", "mousewheel", "show-dots", "touchable", "interval", "effect", "transition-props", "transition-style", "current-index"]));
  }
}), z = /* @__PURE__ */ C(D, [["__scopeId", "data-v-340e80ef"]]);
export {
  z as default
};
